import { ApiResponseError, FailedRequestReason, OfflineRequestError } from 'utils/errorCodes'

// fetch's network TypeError as Chromium, WebKit and Firefox word it; Sentry's
// enhanceFetchErrorMessages, when on, appends " (<host>)"
const FETCH_NETWORK_ERROR_MESSAGE =
  /^(Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.)( \([^()]+\))?$/

export const classifyRequestError = (error: unknown): { requestError: Error; retryable: boolean } => {
  if (error instanceof OfflineRequestError) return { requestError: error, retryable: true }

  if (error instanceof ApiResponseError) return { requestError: error, retryable: error.retryable }

  if (error instanceof Error && error.name === 'AbortError') {
    return { requestError: new OfflineRequestError(FailedRequestReason.TIMEOUT), retryable: true }
  }

  if (error instanceof TypeError && FETCH_NETWORK_ERROR_MESSAGE.test(error.message)) {
    return { requestError: new OfflineRequestError(FailedRequestReason.OFFLINE), retryable: true }
  }

  return { requestError: error as Error, retryable: false }
}
